import { MenuPoint } from '@agilox/ui-common';
import { planMenuPoints } from './menupoints';

export const desktopMenuPoints: MenuPoint[] = [
	planMenuPoints.dashboard,
	planMenuPoints.mapEditor,
	planMenuPoints.aiWorkflows,
	planMenuPoints.workflows,
	planMenuPoints.help,
	planMenuPoints.logout,
];
